import { setFilter } from "../exchangeMemberUXSlice";
import { setData } from "../exchangeMemberDataSlice";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import React from "react";
import { ExchangeMemebersFilter } from "../types";
import { useCopiedState } from "../../../../core/util/hooks";

export const useExchangeMembersReportFilter = () => {
  const storeFilter = useSelector<StoreType, ExchangeMemebersFilter>(
    (store) => store.ux.reports.exchmembers.filter
  );
  const [filter, editFilter] = useCopiedState<ExchangeMemebersFilter>(
    storeFilter
  );

  const dispatch = useDispatch();
  const dispatchSetFilter = React.useCallback(() => {
    dispatch(setFilter(filter!));
    dispatch(setData());
  }, [dispatch, filter]);

  return [filter, editFilter, dispatchSetFilter] as [
    typeof filter,
    typeof editFilter,
    typeof dispatchSetFilter
  ];
};
